<template>
    <el-dialog title="填写说明" class="el-my-dialog" center width="800px" :visible.sync="dialogVisible">
        <div class="my-content">
            <h3>
                此表单由供应商人员进行填写，提交后信息将自动同步至医院端作为合同信息，请认真填写。
            </h3>
            <p>
                1、检查供应商企业资质是否完善，如果尚未完善，系统会自动提示，需点击“前往完善”进行资质信息填写；
            </p>
            <p>
                2、合同信息属于医院重要隐私数据，请认真完善每项内容，注意数据安全，切勿泄露；
            </p>
            <p>
                3、红色“*”号项为必填项，提交表单前请认真检查必填项是否填写完整，如果未填写完整则无法正常提交。
            </p>
            <p>4、填写过程中如关闭网页，将不会保存所填信息，请慎重！</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">已明白</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: "describeDialog",
    data() {
        return {
            dialogVisible: true
        };
    },
    components: {},
    computed: {},
    mounted() {},
    methods: {}
};
</script>

<style  lang="scss">
    .el-my-dialog{
        .my-content{
            margin: 10px;
            h3{
                font-size: 14px;
                color: #333333;
            }
            p{
                font-size: 14px;
                color: #666666;
                margin-bottom:10px;
            }
        }
        .el-dialog__header{
            border-bottom: 1px solid #cccccc;
        }
    }
   
</style>



// WEBPACK FOOTER //
// src/components/supplierCollaboration/describeDialog.vue